export enum QueryParam {
    Logout = 'logout'
}
